module.exports = __webpack_public_path__ + "static/michael-longmire-3Mu0iQgLQto-unsplash-795cf8a4ca4ccdd9ebc4412f925a22f1.jpg";